import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "7", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "18 13 12 7 6 13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 3h14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUpToLine";
const ArrowUpToLine = memo(themed(Icon));
export {
  ArrowUpToLine
};
//# sourceMappingURL=arrow-up-to-line.js.map
